/**
 * User-facing copy for report access gating (`inspection.lockReport`, agreement
 * template `lockReports`). Avoids generic "locked / unlocked" wording that reads
 * like clients can never access reports (ATT-1433).
 */

/** Work order Reports panel: `lockReport` is not false */
export const REPORT_GATE_LABEL_ON = 'Requires Payment & Agreement';

/** Work order Reports panel: `lockReport` is explicitly false */
export const REPORT_GATE_LABEL_OFF = 'Report(s) Unlocked';

export function reportGateSwitchAriaLabel(requiresGate: boolean): string {
  return requiresGate
    ? 'Require payment and agreement before clients can view reports'
    : 'Allow clients to view reports without requiring payment or agreements';
}

/** New job scheduling: visible switch label (HeroUI uses this as the control's accessible name). */
export const REPORT_GATE_SCHEDULING_SWITCH_LABEL = 'Require payment & agreement';

export const REPORT_GATE_SCHEDULING_HELP =
  'When enabled, reports stay hidden in the client portal until the job is paid and agreements are signed.';

/**
 * Agreement template editor (`lockReports`) and service settings chips:
 * same wording for “gated before clients can view reports” vs not.
 */
export const REPORT_GATE_TEMPLATE_ACCESS_REQUIRED = 'Required';

export const REPORT_GATE_TEMPLATE_ACCESS_NOT_REQUIRED = 'Not Required';

export function reportGateTemplateLockReportsAriaLabel(
  requiresGate: boolean
): string {
  return requiresGate
    ? 'Required: clients must complete payment and required agreements before viewing reports'
    : 'Not required: clients can view reports without this agreement gating report access';
}

/** Client direct report URL when access is blocked */
export const REPORT_GATE_CLIENT_SCREEN_HEADING = 'Payment or agreement required';

export const REPORT_GATE_TOAST_ENABLED_DESCRIPTION =
  'Clients must complete payment and required agreements before viewing reports.';

export const REPORT_GATE_TOAST_DISABLED_DESCRIPTION =
  'Clients can view reports without completing payment or agreements.';

export const REPORT_GATE_TOAST_ERROR_DESCRIPTION =
  'Could not update report access settings. Please try again.';

export const REPORT_GATE_DISABLE_MODAL_TITLE =
  'Stop requiring payment and agreement?';

export const REPORT_GATE_DISABLE_MODAL_ACCEPT = 'Yes, allow access';

export const REPORT_GATE_DISABLE_MODAL_BODY =
  'Clients will be able to open reports even if the job is unpaid or agreements are unsigned.';
